import styled from "styled-components";

export default styled.a`
    text-align: center;
    padding: 14px 21px;
    margin: 0 auto 33px;
    border: 0;
    cursor: pointer;
    font-weight: 700;
    font-size: 20px;
    line-height: 17px;
    float: left;
    margin-top: 20px;
    color: #8C8FA8;
`;
